import API from "./api";

export async function getThemes() {
    const res = await API.get("/website/themes");
    return res.data;
}

export async function createAndQueueProject(payload) {
    const res = await API.post("/website/generate", payload);
    return res.data;
}

export async function getPreview(projectId) {
    const res = await API.get(`/website/${projectId}/preview`);
    return res.data;
}

export async function publishProject(projectId) {
    const res = await API.post(`/website/${projectId}/publish`);
    return res.data;
}

export async function autofillWebsiteForm(payload) {
    const res = await API.post("/website/autofill", payload);
    return res.data;
}